import ApiConstant from "../../constants/api.constants";
import api from "../api";
import { InvoiceCheckoutModel } from "../../models/invoice/invoice-checkout-model";

const GenerateNewInvoice = async (invoice: InvoiceCheckoutModel) => {
  try {
    return await api
      .post(ApiConstant.generateNewInvoice, invoice, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in generating invoice");
  }
};

const PaymentInvoice = async (invoiceId: number, payId: number) => {
  const payRequest: {invoiceNumber: number, paymentModeID: number} = {invoiceNumber: invoiceId, paymentModeID: payId};
  try {
    return await api
      .post(ApiConstant.paymentInvoice, payRequest, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in invoice payment");
  }
};

const OthersPayment = async (otherPaymentData: any) => {
  try {
    return await api
      .post(ApiConstant.othersPayment, otherPaymentData, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in Others payment mode");
  }
};

const InsertProductToInvoice = async (orderDetail: any) => {
  try {
    return await api
      .post(ApiConstant.insertProductToInvoice, orderDetail, {
        headers: {
          "content-type": "application/json",
        },
      })
      .then(function (response: any) {
        if (response) {
          return response.data;
        }
      })
      .catch(function (error) {
        return error;
      });
  } catch {
    console.log("error in Others payment mode");
  }
};


const InvoiceServices = {
    GenerateNewInvoice,
    PaymentInvoice,
    OthersPayment,
    InsertProductToInvoice
};

export default InvoiceServices;